import React, { createContext, useState, useEffect } from "react";
import { api } from "../utils/api";

const StoryContext = createContext();

const StoriesProvider = ({ children }) => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get("/api/stories")
      .then((res) => {
        setStories(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <StoryContext.Provider value={{ stories, loading, error }}>
      {children}
    </StoryContext.Provider>
  );
};

export { StoryContext, StoriesProvider };
